import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let lenisInstance = null;
let tickerCallback = null;

/**
 * Initialize Lenis smooth scroll
 * @returns {Lenis} The Lenis instance
 */
export const initLenis = () => {
	if (lenisInstance) {
		lenisInstance.destroy();
		// Remove old ticker callback
		if (tickerCallback) {
			gsap.ticker.remove(tickerCallback);
		}
	}

	lenisInstance = new Lenis({
		duration: 1.6,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: "vertical",
		smooth: true,
		smoothTouch: false,
	});

	lenisInstance.on("scroll", ScrollTrigger.update);

	// Store the ticker callback so we can remove it later
	tickerCallback = (time) => {
		lenisInstance.raf(time * 1000);
	};
	gsap.ticker.add(tickerCallback);
	gsap.ticker.lagSmoothing(0);

	return lenisInstance;
};

/**
 * Get the current Lenis instance
 * @returns {Lenis|null} The current Lenis instance or null
 */
export const getLenis = () => lenisInstance;

/**
 * Cleanup Lenis instance
 * @returns {void}
 */
export const cleanupLenis = () => {
	if (lenisInstance) {
		lenisInstance.destroy();
		lenisInstance = null;
	}
	if (tickerCallback) {
		gsap.ticker.remove(tickerCallback);
		tickerCallback = null;
	}
};
